import { render } from "./MedicineTab.vue?vue&type=template&id=1f9ef441"
import script from "./MedicineTab.vue?vue&type=script&lang=js"
export * from "./MedicineTab.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__